import { useState, CSSProperties } from "react";
import { Button, FormControl, Tooltip, OverlayTrigger } from "react-bootstrap";

const rulesetNameRegex = new RegExp("^[a-zA-Z0-9_]+$");

const buttonStyle: CSSProperties = {
  textTransform: "capitalize",
  marginLeft: "10px"
};

const checkRuleSetNameErrors = (rulesetName: string) => {
  const rules = [
    {
      ruleMatched: rulesetName === "",
      msg: "Ruleset name cannot be empty!"
    },
    {
      ruleMatched: rulesetName.length < 3 || rulesetName.length > 48,
      msg: "Ruleset must be between 3 and 48 characters. Please, type a different name..."
    },
    {
      ruleMatched: !rulesetNameRegex.test(rulesetName),
      msg: "Ruleset contains illegal character(s). Please, type a different name..."
    }
  ];
  return rules.find(rule => rule.ruleMatched)?.msg;
};

interface IYaraRulesetNameInput {
  rulesetName: string;
  onChange: (value: string, isError: boolean) => void;
  onRenameModeChange: (value: boolean) => void;
  disabled: boolean;
  editMode: boolean;
}

const YaraRulesetNameInput = ({
  rulesetName,
  onChange,
  onRenameModeChange,
  disabled,
  editMode
}: IYaraRulesetNameInput) => {
  const [errMsg, setErrMsg] = useState<string>();
  const [renameMode, setRenameMode] = useState<boolean>(false);
  const [originalName, setOriginalName] = useState<string>(rulesetName);
  const handleRename = (currentRename: boolean) => {
    if (!originalName) {
      setOriginalName(rulesetName);
    }
    setRenameMode(!currentRename);
    onRenameModeChange(!currentRename);
  };

  const showRenameButtons = !disabled && editMode;

  const renameButtons = renameMode ? (
    <>
      <Button
        style={buttonStyle}
        disabled={!!errMsg}
        variant="prompt-primary"
        onClick={() => handleRename(renameMode)}
      >
        Confirm
      </Button>
      <Button
        style={buttonStyle}
        variant="prompt-secondary"
        onClick={() => {
          onChange(originalName, false);
          setErrMsg("");
          handleRename(renameMode);
        }}
      >
        Cancel
      </Button>
    </>
  ) : (
    <Button
      style={buttonStyle}
      variant="outline-dark"
      onClick={() => handleRename(renameMode)}
    >
      Rename
    </Button>
  );

  return (
    <div className="width-100-pc" style={{ marginTop: "3px" }}>
      <span>Ruleset Name:</span>
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <OverlayTrigger
          overlay={
            <Tooltip id="yara-ruleset-err" className="ruleset-err-tooltip">
              {errMsg}
            </Tooltip>
          }
          show={!!errMsg}
          placement="top"
        >
          <FormControl
            disabled={editMode && !renameMode}
            id="ruleset-name-id"
            data-testid="yara_ruleset_name_input"
            className="yara-editor-ruleset"
            style={{ width: "60%", marginTop: "3px" }}
            size="sm"
            type="text"
            placeholder="Enter ruleset name"
            value={rulesetName}
            isInvalid={!!errMsg}
            onChange={e => {
              const err = checkRuleSetNameErrors(e.target.value);
              onChange(e.target.value, !!err);
              setErrMsg(err);
            }}
          />
        </OverlayTrigger>
        {showRenameButtons && renameButtons}
      </div>
    </div>
  );
};

export default YaraRulesetNameInput;
